import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import RichEditor from './RichEditor/RichEditor';
import RichEditorPreview from './RichEditor/RichEditorPreview';
import EditorFormRow from './EditorFormRow/EditorFormRow';
import Editor from './EditorFormRow/Editor';
import EditorInline from './EditorFormRow/EditorInline';
import FormToggle from './FormToggle';

import { useI18n } from '@hydra/common/customHooks';
import { CriteriumDeprecationLabel } from '@hydra/common/criterium';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 0),
    '& > div': {
      padding: 0
    },
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-of-type': {
      borderBottom: 0
    }
  }
}));

export const CriteriaManagementSection = ({
  template,
  section,
  editing,
  editingValue,
  setEditingValue,
  setEditingField,
  resetEditing,
  saveFormField
}) => {
  const { translate } = useI18n();
  const classes = useStyles();
  return (
    <>
      {
        section.criteria
          .map(crit => {
            const { enabled = true, customText = null } = template.customCriteria[crit];
            const swCriteria = ['traffic_top_countries', 'traffic_monthly_visits', 'traffic_engagement', 'traffic_sources'].includes(crit);
            const forceLockedToggle = swCriteria && !enabled;
            return (
              <div key={crit} className={classes.root}>
                {
                  swCriteria ? <CriteriumDeprecationLabel /> : null
                }
                <EditorFormRow
                  label={<Translate content={crit} />}
                  noBorder
                >
                  <EditorInline
                    locked={forceLockedToggle}
                    Component={FormToggle}
                    field={`customCriteria.${crit}.enabled`}
                    value={enabled}
                    otherFieldOpen={(editing !== null && editing !== 'applyCustomCriteria')}
                    saveFormField={({ value }) => saveFormField({
                      field: 'customCriteria',
                      value: {
                        ...template.customCriteria,
                        [crit]: {
                          ...template.customCriteria[crit],
                          enabled: value
                        }
                      }
                    })}
                  />
                </EditorFormRow>

                <EditorFormRow
                  label={<Translate content='pdf_editor_option_label_advice_text' />}
                  noBorder
                >
                  <Editor
                    placeholder={translate('pdf_editor_option_placeholder_advice_text')}
                    disabled={!enabled}
                    Component={RichEditor}
                    field={`customCriteria.${crit}.customText`}
                    preview={
                      <RichEditorPreview
                        content={customText}
                        defaultContent={<Translate content='pdf_editor_option_default_content_advice_text' />}
                      />
                    }
                    value={customText}
                    editingValue={editingValue}
                    editing={editing === `customCriteria.${crit}.customText`}
                    otherFieldOpen={(editing !== null && editing !== `customCriteria.${crit}.customText`)}
                    setEditingValue={setEditingValue}
                    setEditingField={setEditingField}
                    resetEditing={resetEditing}
                    saveFormField={({ value }) => saveFormField({
                      field: 'customCriteria',
                      value: {
                        ...template.customCriteria,
                        [crit]: {
                          ...template.customCriteria[crit],
                          customText: value
                        }
                      }
                    })}
                  />
                </EditorFormRow>
              </div>
            );
          })
      }
    </>
  );
};

CriteriaManagementSection.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.string
  }),
  section: PropTypes.shape({
    criteria: PropTypes.arrayOf(PropTypes.string)
  })
};

export default CriteriaManagementSection;
